import axios from 'axios'

export const getCompanyEffectiveTaxRates = (taskId) =>
    axios.get(`advisor/task/${taskId}/effective-tax-rate`)
        .then(({ data }) => data)

export const updateCompanyEffectiveTaxRates = (taskId, rates) =>
    axios.patch(`advisor/task/${taskId}/effective-tax-rate`, rates)
        .then(({ data }) => data)
